module.exports = __webpack_public_path__ + "static/img/01.4e8d3ff2.png";